module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/18WCVAm/tc-custom/9781452135601.jpg?1721404338821",
      "alt": "This image is the cover for the book Little Book of Yoga"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Little Book of Yoga\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A concise overview of the ancient mind-body practice, covering the poses, history, philosophy, and more.")]), _c('br'), _c('br'), _c('i', [_vm._v("The Little Book of Yoga")]), _vm._v(" offers a comprehensive foundation in the practice of yoga. It’s an engaging and approachable volume perfect for yoga lovers of all levels—beginner or advanced, committed or just curious. Beginning with a brief history of yoga and its various styles, Nora Isaacs presents instructions and illustrations for all the major poses. She also goes beyond the poses to discuss yogic philosophy, breathing, meditation, chakras, and more.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Nora Isaacs\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Nora Isaacs, formerly an editor at Yoga Journal, is a writer and editor living in Berkeley, California.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Chronicle Books LLC\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0